<!-- @format -->

<template>
	<el-tooltip v-if="type === 'tooltip'" ref="el" :effect="effect" :placement="placement">
		<el-icon :style="style">
			<QuestionFilled />
		</el-icon>

		<template v-if="$slots.content" #content>
			<div v-html="showContent" />
		</template>
		<template v-else #content>
			<div v-html="showContent" />
		</template>
	</el-tooltip>

	<el-popover v-else ref="el" :width="width" :title="showTitle" :placement="placement" :trigger="trigger">
		<template #reference>
			<!-- <i class="ibps-help-icon" :style="style" :class="[icon]" /> -->
			<el-icon :style="style">
				<QuestionFilled />
			</el-icon>
		</template>
		<template v-if="$slots.content">
			<slot name="content" />
		</template>
		<div v-else v-html="showContent" />
	</el-popover>
</template>
<script>
	import { debounce } from '@power/utils';
	import { $utils } from '@/utils/publicUtils';

	export default {
		props: {
			title: String,
			content: String,
			color: {
				type: String,
				default: '#cacad3',
			},
			type: {
				type: String,
				default: 'popover',
			},
			width: {
				type: [Number, String],
				default: 250,
			},
			effect: {
				type: String,
				default: 'dark',
			},
			placement: {
				type: String,
				default: 'top',
			},
			icon: {
				type: String,
				default: 'QuestionFilled',
			},
			trigger: {
				type: String,
				default: 'hover',
			},
		},
		computed: {
			style() {
				const _style = {};
				if ($utils.isNotEmpty(this.color)) {
					_style.color = this.color;
				}
				return _style;
			},
			showTitle() {
				return this.title || '';
			},
			showContent() {
				return this.content;
			},
		},
		beforeUnmount() {
			// 重复销毁
			debounce(() => {
				if (this.$refs.el) {
					this.$refs.el.destroyPopper && this.$refs.el.destroyPopper();
					this.$refs.el.doDestroy && this.$refs.el.doDestroy(true);
					if (this.$refs.el.popperVM) {
						this.$refs.el.popperVM && this.$refs.el.popperVM.$destroy();
						this.$refs.el.popperVM = null;
					}
				}
			}, 100);
		},
	};
</script>
